// EVA-300: the "this figure is being recalculated" state behind the floating
// Value Conclusion panel and the Valuation Summary tab.
//
// Both answer a ValuationChannel pulse with a 1500ms debounce and then a
// deliberately SILENT refetch — silent because a spinner tears the view down
// and blanks it mid-edit (EVA-275). That leaves a window of ~1.5s in which
// stale numbers are on screen presented as final. Measured on a 27-tenant,
// 120-month valuation the server rebuild is 42ms (panel scope) and 209ms with
// the 81-scenario sensitivity, so the debounce is ~90% of that window: the
// figures are not slow to compute, they are deliberately not asked for yet.
//
// Pure ESM with no React so spec/javascript can probe it — the components own
// markup and fetching, useValuationPulse owns the subscription and the timer.

export const INITIAL_PULSE_STATE = { seq: 0, pending: false }

// A pulse arrived. Pending goes true here, BEFORE the debounce and before any
// request leaves — that is the whole point of the ticket: the user must learn
// the figure is provisional at the moment they change something, not 1.5s
// later. `seq` names the pulse, and is what a settling request is checked
// against below.
export function pulsed(state) {
  return { seq: state.seq + 1, pending: true }
}

// A refetch applied. `startedSeq` is the pulse it left to answer, and the
// caller must capture it BEFORE awaiting. Reading it back out of the state
// here would be wrong, and was: the debounce is re-armed per pulse but its
// callback is async, so a request that outlives the window — 1.5s, ordinary on
// bad wifi — runs alongside its own successor. Shared state would by then name
// the newer request, the older one's settle would pass the comparison, and
// pending would clear over figures that predate the last edit. That is the
// ticket's own symptom, reintroduced by the thing meant to fix it (EVA-300
// review).
//
// A settle with no start before it (`startedSeq` undefined) fails the same
// comparison and is ignored, so a stray timer cannot clear a pending that a
// pulse has just set.
export function fetchSettled(state, startedSeq) {
  if (state.seq !== startedSeq) return state

  return { ...state, pending: false }
}
